import {Component, ElementRef, EventEmitter, HostListener, inject, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PolarisModelVersion} from '../../../../services/polaris/model';

export interface PolarisModelOption {
  value: PolarisModelVersion;
  label: string;
}

export const POLARIS_MODEL_OPTIONS: PolarisModelOption[] = [
  {value: 'v1', label: 'Polaris V1'},
  {value: 'v2', label: 'Polaris V2'}
];

@Component({
  selector: 'app-polaris-model-selector',
  imports: [CommonModule],
  templateUrl: './polaris-model-selector.component.html',
  styleUrl: './polaris-model-selector.component.scss'
})
export class PolarisModelSelectorComponent {
  private elementRef = inject(ElementRef);

  @Input() selectedModel: PolarisModelVersion = 'v1';
  @Input() disabled = false;
  @Input() availableModels: PolarisModelOption[] = POLARIS_MODEL_OPTIONS;
  @Output() modelChange = new EventEmitter<PolarisModelVersion>();

  isOpen = false;

  get selectedLabel(): string {
    return this.availableModels.find(m => m.value === this.selectedModel)?.label ?? 'Polaris V1';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  toggleDropdown(): void {
    if (this.disabled) return;
    this.isOpen = !this.isOpen;
  }

  selectModel(model: PolarisModelOption): void {
    if (this.disabled || model.value === this.selectedModel) {
      this.isOpen = false;
      return;
    }
    this.selectedModel = model.value;
    this.modelChange.emit(model.value);
    this.isOpen = false;
  }
}
